import type { VoidFunctionComponent } from 'react';

import { useReportFlow } from '../hooks/useReportFlow';

import { CustomOptions } from './CustomOptions';
import { StandardOptions } from './StandardOptions';

/**
 * The main component which renders the report options.
 * It is aware of the report flow (standard vs custom) and renders the appropriate options.
 */
export const ReportOptions: VoidFunctionComponent = () => {
  const [flow] = useReportFlow();
  return flow === 'custom' ? <CustomOptions /> : <StandardOptions />;
};
